import React, { useMemo } from 'react';
import { CollapsibleDetailsSection } from '../../components/sections/CollapsibleDetailsSection';
import { PAYMENT_DETAILS } from '@shared/data';
import { PaymentAdapter } from '@shared/adapters';
import type { Transaction } from '@shared/types/payment.types';

interface PaymentDetailsSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  transactionData?: Record<string, unknown>;
}

export const PaymentDetailsSection = React.memo<PaymentDetailsSectionProps>(({
  isExpanded,
  onToggle,
  isDetailView = false,
  transactionData
}) => {
  // Use transaction data if available, otherwise fall back to mockup data
  const details = useMemo(() => {
    if (transactionData) {
      return new PaymentAdapter().adapt(transactionData as unknown as Transaction);
    }
    return PAYMENT_DETAILS;
  }, [transactionData]);

  return (
    <CollapsibleDetailsSection
      title="Payment details"
      details={details}
      isExpanded={isExpanded}
      onToggle={onToggle}
      visibleCount={8}
      isDetailView={isDetailView}
      emptyMessage="No payment details available"
    />
  );
});

PaymentDetailsSection.displayName = 'PaymentDetailsSection';